export const educationData = [
    {
        id: 1,
        institution: 'Akper Ngesti Waluyo',
        course: 'D3 Keperawatan',
        startYear: '2008',
        endYear: '2010'
    },
    {
        id: 2,
        institution: 'Medical Education Center',
        course: 'Certificated Skill Modern Circumcision',
        startYear: '2022',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Wahidev Academy',
        course: 'Software Enginer',
        startYear: '2019',
        endYear: '2019'
    },
]